// 纹理背景配置
// 按类别组织纹理背景

// 1. 基础纹理 - 包括纸张、大理石、织物等自然材质
const basicTextures = {
    basic_paper: {
        class: 'bg-amber-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCI+PGZpbHRlciBpZD0iYSIgeD0iMCIgeT0iMCIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj48ZmVUdXJidWxlbmNlIHR5cGU9ImZyYWN0YWxOb2lzZSIgYmFzZUZyZXF1ZW5jeT0iLjY1IiBudW1PY3RhdmVzPSIzIiBzdGl0Y2hUaWxlcz0ic3RpdGNoIiByZXN1bHQ9InR1cmJ1bGVuY2UiLz48ZmVDb2xvck1hdHJpeCB0eXBlPSJzYXR1cmF0ZSIgdmFsdWVzPSIwIiBpbj0idHVyYnVsZW5jZSIgcmVzdWx0PSJjb2xvcm1hdHJpeCIvPjxmZUNvbXBvbmVudFRyYW5zZmVyIGluPSJjb2xvcm1hdHJpeCIgcmVzdWx0PSJjb21wb25lbnRUcmFuc2ZlciI+PGZlRnVuY1IgdHlwZT0ibGluZWFyIiBzbG9wZT0iMC40IiBpbnRlcmNlcHQ9IjAuOCIvPjxmZUZ1bmNHIHR5cGU9ImxpbmVhciIgc2xvcGU9IjAuNCIgaW50ZXJjZXB0PSIwLjgiLz48ZmVGdW5jQiB0eXBlPSJsaW5lYXIiIHNsb3BlPSIwLjQiIGludGVyY2VwdD0iMC44Ii8+PC9mZUNvbXBvbmVudFRyYW5zZmVyPjwvZmlsdGVyPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbHRlcj0idXJsKCNhKSIgb3BhY2l0eT0iLjA3Ii8+PC9zdmc+',
            width: 100,
            height: 100,
            backgroundColor: '#fffbeb',
        },
    },
    basic_canvas: {
        class: 'bg-gray-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCI+PGZpbHRlciBpZD0iYSI+PGZlVHVyYnVsZW5jZSBiYXNlRnJlcXVlbmN5PSIuMiIgbnVtT2N0YXZlcz0iNCIgc3RpdGNoVGlsZXM9InN0aXRjaCIgcmVzdWx0PSJ0Ii8+PGZlQ29sb3JNYXRyaXggdHlwZT0ic2F0dXJhdGUiIHZhbHVlcz0iMCIvPjwvZmlsdGVyPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbHRlcj0idXJsKCNhKSIgb3BhY2l0eT0iLjA1Ii8+PC9zdmc+',
            width: 40,
            height: 40,
            backgroundColor: '#f9fafb',
        },
    },
    basic_marble: {
        class: 'bg-white',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIj48ZmlsdGVyIGlkPSJhIj48ZmVUdXJidWxlbmNlIHR5cGU9InR1cmJ1bGVuY2UiIGJhc2VGcmVxdWVuY3k9Ii4wMDUiIG51bU9jdGF2ZXM9IjIiIHN0aXRjaFRpbGVzPSJzdGl0Y2giIHJlc3VsdD0idCIvPjxmZURpc3BsYWNlbWVudE1hcCBpbj0iU291cmNlR3JhcGhpYyIgc2NhbGU9IjYwIiB4Q2hhbm5lbFNlbGVjdG9yPSJSIiB5Q2hhbm5lbFNlbGVjdG9yPSJHIi8+PC9maWx0ZXI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJyZ2JhKDAsIDAsIDAsIDAuMDUpIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWRhc2hhcnJheT0iMSIgZmlsdGVyPSJ1cmwoI2EpIi8+PC9zdmc+',
            width: 100,
            height: 100,
            backgroundColor: '#ffffff',
        },
    },
    basic_linen: {
        class: 'bg-neutral-100',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PHBhdHRlcm4gaWQ9ImEiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiIHdpZHRoPSI0IiBoZWlnaHQ9IjQiIHBhdHRlcm5UcmFuc2Zvcm09InJvdGF0ZSg0NSkiPjxwYXRoIGQ9Ik0tMSAxaDJ2MWgtMnoiIGZpbGw9InJnYmEoMCwwLDAsMC4wMikiIGZpbGwtb3BhY2l0eT0iMC41Ii8+PC9wYXR0ZXJuPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjYSkiLz48L3N2Zz4=',
            width: 20,
            height: 20,
            backgroundColor: '#f5f5f5',
        },
    },
    basic_rice_paper: {
        class: 'bg-stone-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCI+PGZpbHRlciBpZD0iYSI+PGZlVHVyYnVsZW5jZSB0eXBlPSJmcmFjdGFsTm9pc2UiIGJhc2VGcmVxdWVuY3k9Ii44IiBudW1PY3RhdmVzPSI0IiBzdGl0Y2hUaWxlcz0ic3RpdGNoIiByZXN1bHQ9InQiLz48ZmVDb2xvck1hdHJpeCB0eXBlPSJzYXR1cmF0ZSIgdmFsdWVzPSIwIiBpbj0idCIvPjwvZmlsdGVyPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbHRlcj0idXJsKCNhKSIgb3BhY2l0eT0iLjAzIi8+PC9zdmc+',
            width: 50,
            height: 50,
            backgroundColor: '#fafaf9',
        },
    },
};

// 2. 几何纹理 - 包括点、线、网格、多边形等几何图案
const geometricTextures = {
    geo_dots: {
        class: 'bg-white',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iMS41IiBmaWxsPSJyZ2JhKDAsIDAsIDAsIDAuMikiLz48L3N2Zz4=',
            width: 20,
            height: 20,
            backgroundColor: '#ffffff',
        },
    },
    geo_grid: {
        class: 'bg-white',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTAgMGgyMHYyMEgweiIgZmlsbD0ibm9uZSIgLz48cGF0aCBkPSJNMCAwdjIwTTIwIDB2MjBNMCAwaDIwTTAgMjBoMjAiIHN0cm9rZT0icmdiYSgwLDAsMCwwLjA1KSIgc3Ryb2tlLXdpZHRoPSIwLjUiIC8+PC9zdmc+',
            width: 20,
            height: 20,
            backgroundColor: '#ffffff',
        },
    },
    geo_honeycomb: {
        class: 'bg-gray-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NiIgaGVpZ2h0PSIxMDAiPjxwYXRoIGQ9Ik0yOCAwTDAgNTB2NTBsNTYtMTAwTTI4IDEwMGwyOC01MFYwTDAgMTAwIiBmaWxsPSJub25lIiBzdHJva2U9InJnYmEoMCwwLDAsMC4wNSkiIHN0cm9rZS13aWR0aD0iMSIvPjwvc3ZnPg==',
            width: 56,
            height: 100,
            backgroundColor: '#f9fafb',
        },
    },
    geo_triangles: {
        class: 'bg-purple-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCI+PHBhdGggZD0iTTAgODBMMTAwIDBIMFYiIGZpbGw9InJnYmEoMTY4LDg1LDI0NywwLjA1KSIvPjwvc3ZnPg==',
            width: 80,
            height: 80,
            backgroundColor: '#faf5ff',
        },
    },
    geo_squares: {
        class: 'bg-white',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTAgMGgxMnYxMkgwem0xMiAxMmgxMnYxMkgxMnoiIGZpbGw9InJnYmEoMCwwLDAsMC4wMikiLz48L3N2Zz4=',
            width: 24,
            height: 24,
            backgroundColor: '#ffffff',
        },
    },
    geo_hexagons: {
        class: 'bg-blue-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCI+PHBhdGggZD0iTTIwIDBsLTE3LjMgMTB2MjBsMTcuMyAxMCAxNy4zLTEwdi0yMHoiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgzNyw5OSwyMzUsMC4xKSIvPjwvc3ZnPg==',
            width: 40,
            height: 40,
            backgroundColor: '#eff6ff',
        },
    },
};

// 3. 线条纹理 - 包括直线、曲线、波浪线等各种线条样式
const lineTextures = {
    line_stripes: {
        class: 'bg-gray-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PHBhdGggZD0iTTAgMGgxME01IDBoMTVNMCA1aDEwTTUgNWgxNU0wIDEwaDE1TTUgMTBoMTVNMCAxNWgxME01IDE1aDE1IiBzdHJva2U9InJnYmEoMCwwLDAsMC4wNSkiIHN0cm9rZS13aWR0aD0iMC41Ii8+PC9zdmc+',
            width: 20,
            height: 20,
            backgroundColor: '#f9fafb',
        },
    },
    line_diagonal: {
        class: 'bg-gray-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PHBhdGggZD0iTTAgMGwyMCAyME0wIDIwTDIwIDAiIHN0cm9rZT0icmdiYSgwLDAsMCwwLjA1KSIgc3Ryb2tlLXdpZHRoPSIwLjUiLz48L3N2Zz4=',
            width: 20,
            height: 20,
            backgroundColor: '#f9fafb',
        },
    },
    line_waves: {
        class: 'bg-blue-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSIxMiI+PHBhdGggZD0iTTAgNmM1IDAgNS02IDEwLTZzNSA2IDEwIDYgNS02IDEwLTYgNSA2IDEwIDYiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgwLDAsMCwwLjA1KSIvPjwvc3ZnPg==',
            width: 40,
            height: 12,
            backgroundColor: '#eff6ff',
        },
    },
    line_zigzag: {
        class: 'bg-indigo-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIxMCI+PHBhdGggZD0iTTAgMGw1IDEwIDUtMTAgNSAxMCA1LTEwIDUgMTAgNS0xMCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJyZ2JhKDc5LDcwLDIyOSwwLjA4KSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9zdmc+',
            width: 30,
            height: 10,
            backgroundColor: '#eef2ff',
        },
    },
    line_dashed: {
        class: 'bg-white',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PHBhdGggZD0iTTAgNUg1TTEwIDVIMTVNMCAxMEg1TTEwIDEwSDE1TTAgMTVINVwxMCAxNUgxNU0wIDBINVxMTAgMEgxNSIgc3Ryb2tlPSJyZ2JhKDAsIDAsIDAsIDAuMDUpIiBzdHJva2Utd2lkdGg9IjEiLz48L3N2Zz4=',
            width: 20,
            height: 20,
            backgroundColor: '#ffffff',
        },
    },
    line_curves: {
        class: 'bg-rose-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MCIgaGVpZ2h0PSIyNSI+PHBhdGggZD0iTTAgMjVjNSAwIDUtMjUgMTAtMjVzNSAyNSAxMCAyNSA1LTI1IDEwLTI1IDUgMjUgMTAgMjUgNS0yNSAxMC0yNSIgc3Ryb2tlPSJyZ2JhKDIyNSw0MCw4MCwwLjA4KSIgc3Ryb2tlLXdpZHRoPSIxLjUiIGZpbGw9Im5vbmUiIC8+PC9zdmc+',
            width: 50,
            height: 25,
            backgroundColor: '#fff1f2',
        },
    },
};

// 4. 深色纹理 - 暗色调且适合作为背景的纹理
const darkTextures = {
    dark_carbon: {
        class: 'bg-gray-900',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHJlY3Qgd2lkdGg9IjgiIGhlaWdodD0iOCIgZmlsbD0iIzJiMmIyYiIvPjxyZWN0IHg9IjgiIHk9IjgiIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIGZpbGw9IiMyYjJiMmIiLz48cmVjdCB4PSI4IiB5PSIwIiB3aWR0aD0iOCIgaGVpZ2h0PSI4IiBmaWxsPSIjMjIyMjIyIi8+PHJlY3QgeD0iMCIgeT0iOCIgd2lkdGg9IjgiIGhlaWdodD0iOCIgZmlsbD0iIzIyMjIyMiIvPjwvc3ZnPg==',
            width: 16,
            height: 16,
            backgroundColor: '#111111',
        }
    },
    dark_vintage: {
        class: 'bg-gray-800',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCI+PHBhdGggZD0iTTMwIDMwTDYwIDBIMFoiIGZpbGw9IiMzMzMzMzMiIG9wYWNpdHk9IjAuMyIvPjxwYXRoIGQ9Ik0zMCAzMEwwIDYwaDYwWiIgZmlsbD0iIzMzMzMzMyIgb3BhY2l0eT0iMC4zIi8+PC9zdmc+',
            width: 60,
            height: 60,
            backgroundColor: '#1f2937',
        }
    },
    dark_dots: {
        class: 'bg-gray-900',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iMiIgZmlsbD0iIzRiNTU2MyIvPjwvc3ZnPg==',
            width: 20,
            height: 20,
            backgroundColor: '#111827',
        }
    },
    dark_grid: {
        class: 'bg-gray-800',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PHBhdGggZD0iTTAgMGgyMHYyMEgweiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMzc0MTUxIiBzdHJva2Utd2lkdGg9IjEiLz48L3N2Zz4=',
            width: 20,
            height: 20,
            backgroundColor: '#1f2937',
        }
    },
    dark_leather: {
        class: 'bg-stone-900',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCI+PGRlZnM+PHBhdHRlcm4gaWQ9ImEiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCI+PHBhdGggZD0iTTAgMGg0MHY0MEgweiIgZmlsbD0iIzI5MjUyNCIvPjxwYXRoIGQ9Ik0wIDIwYzAgNS41NTIzIDQuNDc3MSAxMCAxMCAxMHMxMC00LjQ3NzcgMTAtMTBjMC01LjUyMjktNC40NzcxLTEwLTEwLTEwcy0xMCA0LjQ3NzEtMTAgMTBaIiBmaWxsPSIjNDQzNzM1Ii8+PHBhdGggZD0iTTIwIDIwYzAgNS41NTIzIDQuNDc3MSAxMCAxMCAxMHMxMC00LjQ3NzcgMTAtMTBjMC01LjUyMjktNC40NzcxLTEwLTEwLTEwcy0xMCA0LjQ3NzEtMTAgMTBaIiBmaWxsPSIjNDQzNzM1Ii8+PHBhdGggZD0iTTIwIDBjMCA1LjU1MjMgNC40NzcxIDEwIDEwIDEwczEwLTQuNDc3NyAxMC0xMGMwLTUuNTIyOS00LjQ3NzEtMTAtMTAtMTBTMjAgLTUuNTIyOSAyMCAwWiIgZmlsbD0iIzQ0MzczNSIvPjxwYXRoIGQ9Ik0wIDBjMCA1LjU1MjMgNC40NzcxIDEwIDEwIDEwczEwLTQuNDc3NyAxMC0xMGMwLTUuNTIyOS00LjQ3NzEtMTAtMTAtMTBTMCAtNS41MjI5IDAgMFoiIGZpbGw9IiM0NDM3MzUiLz48cGF0aCBkPSJNMCA0MGMwIDUuNTUyMyA0LjQ3NzEgMTAgMTAgMTBzMTAtNC40Nzc3IDEwLTEwYzAtNS41MjI5LTQuNDc3MS0xMC0xMC0xMHMtMTAgNC40NzcxLTEwIDEwWiIgZmlsbD0iIzQ0MzczNSIvPjxwYXRoIGQ9Ik0yMCA0MGMwIDUuNTUyMyA0LjQ3NzEgMTAgMTAgMTBzMTAtNC40Nzc3IDEwLTEwYzAtNS41MjI5LTQuNDc3MS0xMC0xMC0xMHMtMTAgNC40NzcxLTEwIDEwWiIgZmlsbD0iIzQ0MzczNSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3QgZmlsbD0idXJsKCNhKSIgaGVpZ2h0PSI0MCIgd2lkdGg9IjQwIi8+PC9zdmc+',
            width: 40,
            height: 40,
            backgroundColor: '#1c1917',
        }
    },
    dark_diagonal_stripes: {
        class: 'bg-slate-900',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCI+PHBhdGggZD0iTTAgMGwxMCAxMFpNMTAgMEwwIDEwWiIgc3Ryb2tlPSIjMzM0MTU1IiBzdHJva2Utd2lkdGg9IjEiLz48L3N2Zz4=',
            width: 10,
            height: 10,
            backgroundColor: '#0f172a',
        }
    },
};

// 5. 彩色纹理 - 明亮多彩的纹理和图案
const colorfulTextures = {
    colorful_confetti: {
        class: 'bg-sky-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCI+PGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iMiIgZmlsbD0iI2JhZTZmZCIvPjxjaXJjbGUgY3g9IjMwIiBjeT0iMTAiIHI9IjEuNSIgZmlsbD0iI2E3ZjNkMCIvPjxjaXJjbGUgY3g9IjUwIiBjeT0iMTAiIHI9IjIiIGZpbGw9IiNmYmNmZTgiLz48Y2lyY2xlIGN4PSI3MCIgY3k9IjEwIiByPSIxLjUiIGZpbGw9IiNmY2E1YTUiLz48Y2lyY2xlIGN4PSIyMCIgY3k9IjIwIiByPSIyIiBmaWxsPSIjZmVkN2FhIi8+PGNpcmNsZSBjeD0iNDAiIGN5PSIyMCIgcj0iMS41IiBmaWxsPSIjYzRiNWZkIi8+PGNpcmNsZSBjeD0iNjAiIGN5PSIyMCIgcj0iMiIgZmlsbD0iI2JhZTZmZCIvPjxjaXJjbGUgY3g9IjEwIiBjeT0iMzAiIHI9IjEuNSIgZmlsbD0iI2ZjYTVhNSIvPjxjaXJjbGUgY3g9IjMwIiBjeT0iMzAiIHI9IjIiIGZpbGw9IiNjNGI1ZmQiLz48Y2lyY2xlIGN4PSI1MCIgY3k9IjMwIiByPSIxLjUiIGZpbGw9IiNmZWQ3YWEiLz48Y2lyY2xlIGN4PSI3MCIgY3k9IjMwIiByPSIyIiBmaWxsPSIjYTdmM2QwIi8+PGNpcmNsZSBjeD0iMjAiIGN5PSI0MCIgcj0iMS41IiBmaWxsPSIjZmJjZmU4Ii8+PGNpcmNsZSBjeD0iNDAiIGN5PSI0MCIgcj0iMiIgZmlsbD0iI2ZlZDdhYSIvPjxjaXJjbGUgY3g9IjYwIiBjeT0iNDAiIHI9IjEuNSIgZmlsbD0iI2ZjYTVhNSIvPjxjaXJjbGUgY3g9IjEwIiBjeT0iNTAiIHI9IjIiIGZpbGw9IiNhN2YzZDAiLz48Y2lyY2xlIGN4PSIzMCIgY3k9IjUwIiByPSIxLjUiIGZpbGw9IiNiYWU2ZmQiLz48Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSIyIiBmaWxsPSIjZmNhNWE1Ii8+PGNpcmNsZSBjeD0iNzAiIGN5PSI1MCIgcj0iMS41IiBmaWxsPSIjYzRiNWZkIi8+PGNpcmNsZSBjeD0iMjAiIGN5PSI2MCIgcj0iMiIgZmlsbD0iI2ZlZDdhYSIvPjxjaXJjbGUgY3g9IjQwIiBjeT0iNjAiIHI9IjEuNSIgZmlsbD0iI2ZiY2ZlOCIvPjxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjIiIGZpbGw9IiNiYWU2ZmQiLz48Y2lyY2xlIGN4PSIxMCIgY3k9IjcwIiByPSIxLjUiIGZpbGw9IiNjNGI1ZmQiLz48Y2lyY2xlIGN4PSIzMCIgY3k9IjcwIiByPSIyIiBmaWxsPSIjYTdmM2QwIi8+PGNpcmNsZSBjeD0iNTAiIGN5PSI3MCIgcj0iMS41IiBmaWxsPSIjZmVkN2FhIi8+PGNpcmNsZSBjeD0iNzAiIGN5PSI3MCIgcj0iMiIgZmlsbD0iI2ZiY2ZlOCIvPjwvc3ZnPg==',
            width: 80,
            height: 80,
            backgroundColor: '#f0f9ff',
        }
    },
    colorful_triangles: {
        class: 'bg-pink-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCI+PHBhdGggZD0iTTAgMGgzMHYzMHoiIGZpbGw9IiNmY2QzNGQiIG9wYWNpdHk9IjAuMiIvPjxwYXRoIGQ9Ik0zMCAwaDMwdjMweiIgZmlsbD0iI2Y0M2Y1ZSIgb3BhY2l0eT0iMC4yIi8+PHBhdGggZD0iTTAgMzBoMzB2MzB6IiBmaWxsPSIjMDZiNmQzIiBvcGFjaXR5PSIwLjIiLz48cGF0aCBkPSJNMzAgMzBoMzB2MzB6IiBmaWxsPSIjYTg1NWY3IiBvcGFjaXR5PSIwLjIiLz48L3N2Zz4=',
            width: 60,
            height: 60,
            backgroundColor: '#fdf2f8',
        }
    },
    colorful_bubbles: {
        class: 'bg-blue-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCI+PGNpcmNsZSBjeD0iMTUiIGN5PSIxNSIgcj0iMTAiIGZpbGw9IiM5M2MxZjkiIG9wYWNpdHk9IjAuMyIvPjxjaXJjbGUgY3g9IjQ1IiBjeT0iMTUiIHI9IjUiIGZpbGw9IiM2MGE1ZmEiIG9wYWNpdHk9IjAuMyIvPjxjaXJjbGUgY3g9IjY1IiBjeT0iMjUiIHI9IjgiIGZpbGw9IiMzYjgzZjYiIG9wYWNpdHk9IjAuMyIvPjxjaXJjbGUgY3g9IjI1IiBjeT0iMzUiIHI9IjciIGZpbGw9IiMyNTcyZWMiIG9wYWNpdHk9IjAuMyIvPjxjaXJjbGUgY3g9IjUwIiBjeT0iNDAiIHI9IjEyIiBmaWxsPSIjMWQ0YWJlIiBvcGFjaXR5PSIwLjMiLz48Y2lyY2xlIGN4PSIxNSIgY3k9IjU1IiByPSI1IiBmaWxsPSIjOTNjMWY5IiBvcGFjaXR5PSIwLjMiLz48Y2lyY2xlIGN4PSIzNSIgY3k9IjY1IiByPSI5IiBmaWxsPSIjNjBhNWZhIiBvcGFjaXR5PSIwLjMiLz48Y2lyY2xlIGN4PSI2NSIgY3k9IjY1IiByPSI2IiBmaWxsPSIjMjU3MmVjIiBvcGFjaXR5PSIwLjMiLz48L3N2Zz4=',
            width: 80,
            height: 80,
            backgroundColor: '#eff6ff',
        }
    },
    colorful_mosaic: {
        class: 'bg-emerald-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEwIiBoZWlnaHQ9IjEwIiBmaWxsPSIjMzRkMzk5IiBvcGFjaXR5PSIwLjIiLz48cmVjdCB4PSIxMCIgeT0iMCIgd2lkdGg9IjEwIiBoZWlnaHQ9IjEwIiBmaWxsPSIjMTBiOTgxIiBvcGFjaXR5PSIwLjIiLz48cmVjdCB4PSIyMCIgeT0iMCIgd2lkdGg9IjEwIiBoZWlnaHQ9IjEwIiBmaWxsPSIjMzRkMzk5IiBvcGFjaXR5PSIwLjIiLz48cmVjdCB4PSIzMCIgeT0iMCIgd2lkdGg9IjEwIiBoZWlnaHQ9IjEwIiBmaWxsPSIjMTBiOTgxIiBvcGFjaXR5PSIwLjIiLz48cmVjdCB4PSIwIiB5PSIxMCIgd2lkdGg9IjEwIiBoZWlnaHQ9IjEwIiBmaWxsPSIjMTBiOTgxIiBvcGFjaXR5PSIwLjIiLz48cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgZmlsbD0iIzA2OTY2OCIgb3BhY2l0eT0iMC4yIi8+PHJlY3QgeD0iMjAiIHk9IjEwIiB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIGZpbGw9IiMxMGI5ODEiIG9wYWNpdHk9IjAuMiIvPjxyZWN0IHg9IjMwIiB5PSIxMCIgd2lkdGg9IjEwIiBoZWlnaHQ9IjEwIiBmaWxsPSIjMDY5NjY4IiBvcGFjaXR5PSIwLjIiLz48cmVjdCB4PSIwIiB5PSIyMCIgd2lkdGg9IjEwIiBoZWlnaHQ9IjEwIiBmaWxsPSIjMzRkMzk5IiBvcGFjaXR5PSIwLjIiLz48cmVjdCB4PSIxMCIgeT0iMjAiIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgZmlsbD0iIzEwYjk4MSIgb3BhY2l0eT0iMC4yIi8+PHJlY3QgeD0iMjAiIHk9IjIwIiB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIGZpbGw9IiMzNGQzOTkiIG9wYWNpdHk9IjAuMiIvPjxyZWN0IHg9IjMwIiB5PSIyMCIgd2lkdGg9IjEwIiBoZWlnaHQ9IjEwIiBmaWxsPSIjMTBiOTgxIiBvcGFjaXR5PSIwLjIiLz48cmVjdCB4PSIwIiB5PSIzMCIgd2lkdGg9IjEwIiBoZWlnaHQ9IjEwIiBmaWxsPSIjMTBiOTgxIiBvcGFjaXR5PSIwLjIiLz48cmVjdCB4PSIxMCIgeT0iMzAiIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgZmlsbD0iIzA2OTY2OCIgb3BhY2l0eT0iMC4yIi8+PHJlY3QgeD0iMjAiIHk9IjMwIiB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIGZpbGw9IiMxMGI5ODEiIG9wYWNpdHk9IjAuMiIvPjxyZWN0IHg9IjMwIiB5PSIzMCIgd2lkdGg9IjEwIiBoZWlnaHQ9IjEwIiBmaWxsPSIjMDY5NjY4IiBvcGFjaXR5PSIwLjIiLz48L3N2Zz4=',
            width: 40,
            height: 40,
            backgroundColor: '#ecfdf5',
        }
    },
    colorful_diamonds: {
        class: 'bg-purple-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCI+PHBhdGggZD0iTTIwIDBMMzAgMTBMMjAgMjBMMTAgMTBaIiBmaWxsPSIjYzA4NGZjIiBvcGFjaXR5PSIwLjMiLz48cGF0aCBkPSJNMCAxMEwxMCAyMEwwIDMwTDAgMjBMMCAxMFoiIGZpbGw9IiM4YjVjZjYiIG9wYWNpdHk9IjAuMyIvPjxwYXRoIGQ9Ik0wIDMwTDEwIDQwTDIwIDMwTDEwIDIwWiIgZmlsbD0iI2MwODRmYyIgb3BhY2l0eT0iMC4zIi8+PHBhdGggZD0iTTIwIDIwTDMwIDMwTDQwIDIwTDMwIDEwWiIgZmlsbD0iIzdiMmNiZiIgb3BhY2l0eT0iMC4zIi8+PHBhdGggZD0iTTMwIDMwTDQwIDIwTDQwIDMwTDQwIDQwTDMwIDQwWiIgZmlsbD0iIzhiNWNmNiIgb3BhY2l0eT0iMC4zIi8+PC9zdmc+',
            width: 40,
            height: 40,
            backgroundColor: '#faf5ff',
        }
    },
    colorful_stripes: {
        class: 'bg-amber-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjQwIiBoZWlnaHQ9IjUiIGZpbGw9IiNmYmJmMjQiIG9wYWNpdHk9IjAuMiIvPjxyZWN0IHg9IjAiIHk9IjUiIHdpZHRoPSI0MCIgaGVpZ2h0PSI1IiBmaWxsPSIjZjU5ZTE0IiBvcGFjaXR5PSIwLjIiLz48cmVjdCB4PSIwIiB5PSIxMCIgd2lkdGg9IjQwIiBoZWlnaHQ9IjUiIGZpbGw9IiNkOTc3MDYiIG9wYWNpdHk9IjAuMiIvPjxyZWN0IHg9IjAiIHk9IjE1IiB3aWR0aD0iNDAiIGhlaWdodD0iNSIgZmlsbD0iI2I0NTMwOSIgb3BhY2l0eT0iMC4yIi8+PHJlY3QgeD0iMCIgeT0iMjAiIHdpZHRoPSI0MCIgaGVpZ2h0PSI1IiBmaWxsPSIjZmJiZjI0IiBvcGFjaXR5PSIwLjIiLz48cmVjdCB4PSIwIiB5PSIyNSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjUiIGZpbGw9IiNmNTllMTQiIG9wYWNpdHk9IjAuMiIvPjxyZWN0IHg9IjAiIHk9IjMwIiB3aWR0aD0iNDAiIGhlaWdodD0iNSIgZmlsbD0iI2Q5NzcwNiIgb3BhY2l0eT0iMC4yIi8+PHJlY3QgeD0iMCIgeT0iMzUiIHdpZHRoPSI0MCIgaGVpZ2h0PSI1IiBmaWxsPSIjYjQ1MzA5IiBvcGFjaXR5PSIwLjIiLz48L3N2Zz4=',
            width: 40,
            height: 40,
            backgroundColor: '#fffbeb',
        }
    },
};

// 6. 渐变纹理 - 渐变背景和纹理
const gradientTextures = {
    texture_gradient_blue: {
        class: 'bg-gradient-to-r from-blue-100 to-blue-200',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxkZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0iYSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIwIiB5MT0iMCIgeDI9IjEwMCUiIHkyPSIwIj48c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjZGJlYWZlIiBzdG9wLW9wYWNpdHk9IjEiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNiZmRiZmUiIHN0b3Atb3BhY2l0eT0iMSIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjYSkiLz48L3N2Zz4=',
            width: 100,
            height: 100,
            backgroundColor: '#eff6ff',
        }
    },
    texture_gradient_purple: {
        class: 'bg-gradient-to-r from-purple-100 to-purple-200',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxkZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0iYSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIwIiB5MT0iMCIgeDI9IjEwMCUiIHkyPSIwIj48c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjZjNlOGZmIiBzdG9wLW9wYWNpdHk9IjEiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNlOWQ1ZmYiIHN0b3Atb3BhY2l0eT0iMSIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjYSkiLz48cGF0aCBkPSJNMCAwIEwxMDAgMTAwIE0tMjUgMCBMNzUgMTAwIE0wIC0yNSBMMTAwIDc1IiBzdHJva2U9IiNhMjFjYWYiIHN0cm9rZS13aWR0aD0iMC41IiBzdHJva2Utb3BhY2l0eT0iMC4wNSIvPjwvc3ZnPg==',
            width: 100,
            height: 100,
            backgroundColor: '#faf5ff',
        }
    },
    texture_gradient_teal: {
        class: 'bg-gradient-to-r from-teal-50 to-teal-100',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,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',
            width: 100,
            height: 100,
            backgroundColor: '#ccfbf1',
        }
    },
    texture_gradient_rose: {
        class: 'bg-gradient-to-br from-rose-50 to-pink-100',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxkZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0iYSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIwIiB5MT0iMCIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjZmZmMWYyIiBzdG9wLW9wYWNpdHk9IjEiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNmY2UxZTQiIHN0b3Atb3BhY2l0eT0iMSIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjYSkiLz48cGF0aCBkPSJNMzAgMzBjMCAxNiAxNiAxNiAxNiAwczE2LTE2IDAgLTE2IC0xNiAxNiAtMTYgMHoiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZiYTRiNSIgc3Ryb2tlLXdpZHRoPSIxIiBzdHJva2Utb3BhY2l0eT0iMC4xIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMCwxMCkiLz48cGF0aCBkPSJNMzAgMzBjMCAxNiAxNiAxNiAxNiAwczE2LTE2IDAgLTE2IC0xNiAxNiAtMTYgMHoiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZiYTRiNSIgc3Ryb2tlLXdpZHRoPSIxIiBzdHJva2Utb3BhY2l0eT0iMC4xIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1MCw1MCkiLz48L3N2Zz4=',
            width: 100,
            height: 100,
            backgroundColor: '#fff1f2',
        }
    },
    texture_gradient_amber: {
        class: 'bg-gradient-to-br from-amber-50 to-yellow-100',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxkZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0iYSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIwIiB5MT0iMCIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjZmZmYmViIiBzdG9wLW9wYWNpdHk9IjEiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNmZWYzYzciIHN0b3Atb3BhY2l0eT0iMSIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjYSkiLz48Y2lyY2xlIGN4PSIyNSIgY3k9IjI1IiByPSIxNSIgZmlsbD0iI2ZiYmYyNCIgZmlsbC1vcGFjaXR5PSIwLjAzIi8+PGNpcmNsZSBjeD0iNzUiIGN5PSI3NSIgcj0iMTUiIGZpbGw9IiNmYmJmMjQiIGZpbGwtb3BhY2l0eT0iMC4wMyIvPjwvc3ZnPg==',
            width: 100,
            height: 100,
            backgroundColor: '#fffbeb',
        }
    },
};

// 7. 主题纹理 - 特定风格或主题的纹理
const thematicTextures = {
    theme_minimal: {
        class: 'bg-gray-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCI+PHBhdGggZD0iTTYwIDBoLTEwdjEwaDEwek0wIDUwaDEwdjEwSDB6IiBmaWxsPSIjZjlmYWZiIi8+PC9zdmc+',
            width: 60,
            height: 60,
            backgroundColor: '#f9fafb',
        }
    },
    theme_abstract: {
        class: 'bg-slate-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCI+PGNpcmNsZSBjeD0iNDAiIGN5PSI0MCIgcj0iNDAiIGZpbGw9IiMwMzA0MTIiIGZpbGwtb3BhY2l0eT0iMC4wMiIvPjxjaXJjbGUgY3g9IjQwIiBjeT0iNDAiIHI9IjMwIiBmaWxsPSIjMDIwNDEyIiBmaWxsLW9wYWNpdHk9IjAuMDIiLz48Y2lyY2xlIGN4PSI0MCIgY3k9IjQwIiByPSIyMCIgZmlsbD0iIzAxMDQxMiIgZmlsbC1vcGFjaXR5PSIwLjAyIi8+PC9zdmc+',
            width: 80,
            height: 80,
            backgroundColor: '#f8fafc',
        }
    },
    theme_nature: {
        class: 'bg-green-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCI+PHBhdGggZD0iTTIwIDQwYzAgNCAxMCAxNSAyMCAxNXMyMC0xMSAyMC0xNVMyMCA0MCAyMCA0MHoiIGZpbGw9IiMyMmM1NWUiIGZpbGwtb3BhY2l0eT0iMC4xIi8+PHBhdGggZD0iTTAgMjBjMCAwIDEwIDQwIDQwIDQwUzgwIDMwIDgwIDMwIiBzdHJva2U9IiMxNWMwNTQiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLW9wYWNpdHk9IjAuMDUiIGZpbGw9Im5vbmUiLz48L3N2Zz4=',
            width: 80,
            height: 80,
            backgroundColor: '#f0fdf4',
        }
    },
    theme_retro: {
        class: 'bg-amber-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCI+PHBhdGggZD0iTTAgMGg0MHY0MEgweiIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik0wIDBoMjBMMCAxOXptNDAgMEwyMSAwbDE5IDE5em0wIDQwTDIxIDQwbDE5LTE5ek0wIDQwaDIwTDAgMjF6IiBmaWxsPSIjZmJiZDIzIiBmaWxsLW9wYWNpdHk9IjAuMDUiLz48L3N2Zz4=',
            width: 40,
            height: 40,
            backgroundColor: '#fffbeb',
        }
    },
    theme_tech: {
        class: 'bg-slate-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCI+PHBhdGggZD0iTTAgMGg2MHY2MEgweiIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik0xMCAxMGgxMHYxMEgxMHpNMzAgMTBoMTB2MTBIMzB6TTEwIDMwaDEwdjEwSDEwek0zMCAzMGgxMHYxMEgzMHpNNTAgMTBoMTB2MTBINTB6TTUwIDMwaDEwdjEwSDUwek01MCA1MGgxMHYxMEg1MHpNMTAgNTBoMTB2MTBIMTB6TTMwIDUwaDEwdjEwSDMweiIgZmlsbD0iIzQ3NTU2OSIgZmlsbC1vcGFjaXR5PSIwLjAzIi8+PC9zdmc+',
            width: 60,
            height: 60,
            backgroundColor: '#f8fafc',
        }
    },
    theme_elegant: {
        class: 'bg-indigo-50',
        fill: {
            type: 'pattern',
            url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIj48cGF0aCBkPSJNMCAwaDUwdjUwSDB6TTUwIDUwaDUwdjUwSDUweiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNDMzOGNhIiBzdHJva2Utd2lkdGg9IjEiIHN0cm9rZS1vcGFjaXR5PSIwLjA1Ii8+PHBhdGggZD0iTTUwIDBINzVWMjVINTBNMjUgNTBINTBWNzVIMjVNNzUgNTBIMTAwVjc1SDc1TTAgNTBIMjVWNzVIME01MCAyNUg3NVY1MEg1ME0wIDI1SDI1VjUwSDAiIGZpbGw9IiM0MzM4Y2EiIGZpbGwtb3BhY2l0eT0iMC4wMiIvPjwvc3ZnPg==',
            width: 100,
            height: 100,
            backgroundColor: '#eef2ff',
        }
    },
};

// 最后将所有纹理组合到一起导出
const textureBackgrounds = {
    ...basicTextures,
    ...geometricTextures,
    ...lineTextures,
    ...darkTextures,
    ...colorfulTextures,
    ...gradientTextures,
    ...thematicTextures
};

export default textureBackgrounds; 